<script lang="ts">
    import NauiTable from "../naui/components/NauiTable.svelte";
    import {onMount} from "svelte";
    import type { IDocumentTableData } from "../interfaces";

    export let data: Array<IDocumentTableData>;
    export let documentoLabel = 'Documento';
    export let categoryLabel = 'Categoría';
    export let actionsLabel = '';
    export let category = false;
    export let checkbox = true;
    export let categoryOptions = [];
    export let optionGroup = null;

    let _data: Array<any> = [];

    let columns = [
        {
            slug: 'slug',
            label: '',
            type: 'checkbox',
            width: 'max-content',
            order: false
        },
        {
            slug: 'label',
            label: documentoLabel,
            class: '',
            type: 'text',
            order: false
        },
        {
            slug: 'category',
            label: categoryLabel,
            type: 'select',
            order: false
        },
        {
            slug: 'completed',
            label: 'Estado',
            class: '',
            type: 'icon',
            order: false
        },
        {
            slug: 'file',
            label: '',
            class: '',
            type: 'file',
            order: false
        },
        {
            slug: 'actions',
            label: actionsLabel,
            width: '160px',
            type: 'actions',
        }
    ];

    onMount(() => {
        generateTableSchema();
        runAdaptor();
    });

    function generateTableSchema() {
        if (!category) {
            columns = [...columns.slice(0, 2), ...columns.slice(3)]
        }
        if (!checkbox) {
            columns = [...columns.slice(1)];
        }
    }

    function runAdaptor() {
        _data = data.map((x) => {
            return {
                slug: x.slug,
                label: x.label,
                category: null,
                file: null,
                completed: x.completed ? {
                    icon: 'check',
                    color: 'green',
                    iconFamily: 'far'
                } : {
                    icon: 'times',
                    iconFamily: 'fal',
                    color: 'error'
                },
                actions: getActions(x.route)
            }
        });
    }

    function getActions(route) {
        if (route) {
            return [
                {
                    icon: 'file-download',
                    iconFamily: 'far',
                    slug: 'download',
                    route: route,
                    download: true
                },
                {
                    icon: 'trash',
                    iconFamily: 'far',
                    slug: 'remove',
                }
            ]
        } else {
            return [
                {
                    icon: 'file-download',
                    disabled: true,
                    slug: 'download',
                },
                {
                    icon: 'trash',
                    disabled: true,
                    slug: 'remove',
                }
            ]
        }

    }

</script>
<NauiTable {columns} data={_data} {optionGroup} on:action on:file/>
